import { Field, Float, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { GpsLocation } from './GpsLocation'

@ObjectType()
@InputType('GpsInput')
export class Gps {
  @Field(() => Float)
  @Prop({ type: Number })
  lng?: number

  @Field(() => Float)
  @Prop({ type: Number })
  lat?: number

  @Field(() => Float)
  @Prop({ type: Number })
  alt?: number

  @Field(() => GpsLocation)
  @Prop({ type: GpsLocation })
  location?: GpsLocation
}
